import { createContext } from "common/utils/reactContext";

type FeatureContextType = {
  unifiedPortal?: boolean;
  lpZendeskFeatureFlag?: boolean;
  disregardedEntityQuestionnaire?: boolean;
  hasKycInUnifiedPortal?: boolean;
  dataRoomRestrictDownloads?: boolean;
  hasDynamicSubscriptions?: boolean;
  hasDynamicSubscriptionsCustomSections?: boolean;
  lpRequestManagementM1?: boolean;
  lpRequestManagementM2?: boolean;
  hasLpcmAutomaticUpdateAndRemoval?: boolean;
  deprecateLegacyCustomSections?: boolean;
  hasSubsV3Ui?: boolean;
  enableCoBrowseFeature?: boolean;
  subscriptionSubquestions?: boolean;
  enableLpcmCommPrefsSubscription?: boolean;
  showOwnershipTabWithNewLogic?: boolean;
  staffApprovalForLPInitiatedPaymentPref?: boolean;
};

const [useFeaturesContext, FeaturesProvider] = createContext<FeatureContextType>();
export { FeaturesProvider, useFeaturesContext };
